import { createContext, useContext } from 'react';

export interface TabPaneInfo {
  /** The owning LopTab.key — stable per-pane identity for setDirty/setTitle
   *  calls from anywhere in this pane's subtree, however deep. */
  key: string;
  /** Whether THIS pane is the currently-active (visible) tab. */
  isActive: boolean;
}

/** Provided once per pane by TabHost (plan §3.3/§3.6), memoized per tab so a
 *  dispatch elsewhere in the tabs tree doesn't churn every pane's context
 *  value. `undefined` outside a tab pane (e.g. a screen exercised without
 *  TabHost) — the useTab*() hooks in this folder no-op in that case rather
 *  than throw. Opt-in and cheap by design (plan §3.6). */
export const TabPaneContext = createContext<TabPaneInfo | undefined>(undefined);

export function useTabPaneInfo(): TabPaneInfo | undefined {
  return useContext(TabPaneContext);
}
